export default __webpack_public_path__ + "static/media/3.63c5d7d1.jpg";